module.exports = __webpack_public_path__ + "static/media/unverified.4c3afbfe.svg";